export var getSentryConfig = function (_a) {
    var dsn = _a.dsn, release = _a.release;
    return ({
        dsn: dsn,
        release: release,
        attachStacktrace: true,
        logLevel: 1,
        ignoreErrors: [
            'NavigationDuplicated',
            // 'Invariant Violation',
            'Loading CSS chunk',
            'Loading chunk',
        ],
    });
};
